import { Box, ListItem } from '@mui/material';

interface IPasswordTooltip {
  password: string;
}

const PasswordTooltip: React.FC<IPasswordTooltip> = ({ password }) => {
  const isLowerCase = () => {
    return /(?=.*[a-z])/.test(password);
  };

  const isUpperCase = () => {
    return /(?=.*[A-Z])/.test(password);
  };

  return (
    <Box sx={{ fontSize: 13, margin: 2, color: '#0e0e0e', background: '#fff' }}>
      <ListItem
        sx={{
          display: 'list-item',
          color: isLowerCase() ? '#2eab05' : '',
          padding: '10px 0 5px',
        }}
      >
        Символ в нижнем регистре
      </ListItem>
      <ListItem
        sx={{
          display: 'list-item',
          color: isUpperCase() ? '#2eab05' : '',
          padding: '5px 0',
        }}
      >
        Символ в верхнем регистре
      </ListItem>
      <ListItem
        sx={{
          display: 'list-item',
          color: password.length > 7 ? '#2eab05' : '',
          padding: '5px 0 10px',
        }}
      >
        Минимум 8 символов
      </ListItem>
    </Box>
  );
};

export default PasswordTooltip;
